import { render, staticRenderFns } from "./TransactionCategoryCreate.vue?vue&type=template&id=4cdedbae"
import script from "@/controllers/transaction_category/transaction-category-create.js?vue&type=script&lang=js&external"
export * from "@/controllers/transaction_category/transaction-category-create.js?vue&type=script&lang=js&external"
import style0 from "./TransactionCategoryCreate.vue?vue&type=style&index=0&id=4cdedbae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports